import React from 'react';

class BaseLayer extends React.Component{
    constructor() {
        super();
        this.baseLayerChecked = this.baseLayerChecked.bind(this);
        this.state = {UserSetting:""};
    }
    baseLayerChecked(layers){
        window.main.OView.setBaseLayer({
            url: layers.URL,
            identifier: layers.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
    }
    render(){
        return(
            <div className="ts checkboxes">
                {
                    window.BASE_LAYERS.map(
                    (layers,index)=>
                    index === 0 ?
                    <div className="ts radio checkbox" key={layers.TITLE}>
                        <input type="radio" name="baseLayer" id={layers.TITLE} defaultChecked="checked" onClick={(e)=>this.baseLayerChecked(layers)}></input>
                        <label htmlFor={layers.TITLE}>{layers.TITLE}</label>
                    </div> 
                    :
                    <div className="ts radio checkbox" key={layers.TITLE}>
                        <input type="radio" name="baseLayer" id={layers.TITLE} onClick={(e)=>this.baseLayerChecked(layers)}></input>
                        <label htmlFor={layers.TITLE}>{layers.TITLE}</label>
                    </div>
                    )
                }
            </div>
        );
    }
}

export default BaseLayer;